import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PersonalService } from 'src/app/authentication/services/personal.service';
import { IEmployee } from 'src/app/employee/employee';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { currentEmployeeSelector } from 'src/app/stores/global/current-employee/current-employee.store';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    standalone: false
})
export class ProfileComponent implements OnInit {

  constructor(
    private personalService: PersonalService,
    private appnotificationService: AppNotificationService,
    private store: Store<AppStateInterface>) { }

  public form: UntypedFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    newPassword: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    confirmNewPassword: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
  });

  public currentEmployee$ : Observable<IEmployee> =
  this.store.select(currentEmployeeSelector);


  ngOnInit(): void {
  }

  onSubmit(){
    const formValues = this.form.value;
    this.personalService.changePassword(formValues)
    .subscribe(response => {
      console.log(response);
      this.appnotificationService.notification$.next({message: 
        'Password change successful', style: 'success'})
    })
  }

}
